/**
 * @desc 查询停止拉单店铺
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.platDataFlow.PauseShopRequestParamsDtoObject, options?: any) {
  return updateResponse(
    http(URL + `/pauseShop/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
